import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header1 = _resolveComponent("Header1")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer1 = _resolveComponent("Footer1")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header1),
    _createVNode(_component_router_view),
    _createVNode(_component_Footer1)
  ]))
}